export default __webpack_public_path__ + "static/media/metamask_steps_1.3d3c6140.png";